import * as React from "react";

interface LoadingTextProps {
    text: string;
}

export function LoadingText({ text }: LoadingTextProps) {
    return (
        <div className="loading-text-container">
            <div className="loading-spinner" role="status" aria-label="Loading">
                <div className="spinner-base"></div>
                <div className="spinner-ring"></div>
            </div>
            <p className="loading-text">
                {text}
            </p>
        </div>
    );
}